import { Component, Vue } from 'vue-property-decorator'
import { validUserName } from '../../../helper-functions/validators'
import textInput from '../../../components/text-input/text-input.vue'

const initialState = {
  username: '',
}

@Component({
  components: {
    textInput,
  }
})

export default class ForgotPassword extends Vue {

  public namespace: string = '/Account';
  
  public username: string = '';

  private alertMessage: string = '';

  private disabled: boolean = false;

  private error: boolean = false;

  private submitted: boolean = false;

  private get ValidUsername () {

    return validUserName(this.username)
  }

  private get enabled () {
    
    return this.ValidUsername
      && !this.disabled;
  }

  private clearForm (init?: Partial<ForgotPassword>) {

    Object.assign(this, {...init})
  }
  
  private resetAlert () {

    setTimeout(() => {

      if (this.error) {

        this.error = !this.error;
      }

      this.alertMessage = '';
    }, 5000)
  }

  private async restorePassword () {

    this.submitted = true;

    try {

      const response = await this.$axios.post(`${this.$apiUrl + this.namespace}/ForgotPassword`, {
        username: this.username
      });

      this.submitted = false;
      this.alertMessage = this.$t('account.resetConfirm') as string;
      this.clearForm(initialState);
      this.resetAlert();

    } catch (err) {

      this.submitted = false;
      this.error = !this.error;
      this.alertMessage = this.$t('errors.general') as string;
      this.resetAlert();
    }
  }
}